(function() {
    'use strict';
    angular
        .module('emarket.store.home')
        .controller('StoreHomeController', ['$log', 'Profile', 'profile', function($log, Profile, profile) {
            var vm = this;
            vm.store = profile.store;
            Profile.getRelatedProducts(profile._id).then(function(products) {
                var limit = 5;
                if (!vm.highlightedPosts) {
                    limit += 5;
                }
                if (!vm.seasonPosts) {
                    limit += 5;
                }
                vm.latest = products.splice(0, limit);
            });
        }]);
}());
